/** @jsxImportSource @emotion/react */
import ReactMarkdown from "react-markdown";
import { css } from "@emotion/react";
import remarkGfm from "remark-gfm";

const CommunityPolicyText = `
  ### 제 1조 목적
  본 이용 약관은 “도와줘요, M쌤”의 서비스 이용 조건과 운영에 관한 제반사항 규정을 목적으로 합니다.    

  　

  ### 제 2조 정의

  본 이용 약관에서 사용하는 용어의 정의는 다음과 같습니다.
  
  “서비스”란, 본 사이트에서 제공하는 모든 서비스 및 기능을 말합니다.
  “이용자”란, 이 약관에 따라 서비스를 이용하는 회원 및 비회원을 말합니다.
  “회원”이란, 서비스에 회원 등록을 하고 서비스를 이용하는 자를 말합니다.
  “비회원”이란, 서비스에 회원 등록을 하지 않고 서비스를 이용하는 자를 말합니다.
  “계정”이란, 이용 계약을 통해 생성된 회원의 고유 아이디와 이에 수반하는 정보를 말합니다.
  “커뮤니티”란, 게시물을 게시할 수 있는 공간을 말합니다.
  “관련법”이란, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 전기통신사업법, 개인정보보호법 등 관련 있는 국내 법령을 말합니다.
  
  　

  ### 제 3조 약관의 명시와 회원 가입
1. 이 약관을 서비스 회원가입 화면 및 하단 푸터에 게시하는 방법으로 회원에게 공지합니다.
2. 관리자는 필요하다고 인정되는 경우, 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
3. 회원은 약관의 일부분만 동의 또는 거부할 수 없습니다.
4. 회원이 되고자 하는 자는 회사가 정한 가입 양식에 따라 회원정보를 기입하고 "동의", "확인" 등의 버튼을 누르는 방법으로 회원 가입을 신청합니다.
5. 회원 가입의 성립 시기는 회원 가입 완료 통지가 회원에게 도달하거나, 그에 준하는 권한이 회원에게 부여되는 시점으로 합니다

　

### 제 4조 서비스의 제공 및 변경

1. 회사는 다음 서비스를 제공합니다.
    - 커뮤니티 서비스 (게시판)
    - 토론 커뮤니티 서비스 (과몰입 토론)
    - 1:1 채팅 서비스 (M쌤 매칭)
    - 검색 서비스
    - 기타 서비스
2. 회사는 제공하고 있는 서비스를 변경할 수 있습니다.
3. 회사는 이용자의 서비스 이용 기록에 따라 서비스 이용에 차이를 둘 수 있습니다.
4. 회사는 정보통신설비의 보수, 점검, 교체 등 서비스 중지 및 인터넷 장애 등의 사유로 인해 일시적으로 서비스 제공이 어려울 경우, 사전 통지 없이 일시적으로 서비스 제공을 중단할 수 있습니다.
5. 회사는 경양 악화 등 불가항력적인 사유로 인해 서비스를 더 이상 제공하기 어려울 경우, 서비스 제공을 영구적으로 중단할 수 있습니다. 그러한 경우 제 7조에서 정한 방법으로 회원에게 통지할 수 있습니다.
6. 회사는 서비스 이용 중 다음 내용으로 인해  발생한 피해에 대해 회사의 고의 또는 중대한 과실이 없는 한 어떠한 책임도 지지 않습니다.
    - 이용자의 귀책 사유 또는 회사의 귀책 사유가 아닌 사유로 발생한 이용자의 피해
    - 서비스 이용 중 타인과 상호 간에 합의한 내용
    - 하이퍼링크 등 외부로 연결된 서비스와 같이 회사가 제공하지 않는 서비스에서 발생한 피해
    - 모든 서비스, 게시물, 이용 기록의 무결성, 신뢰성, 이용가능성의 보장

    　

### 제 5조 개인정보의 관리 및 보호

회사는 서비스를 제공하기 위하여 관련 법령의 규정에 따라 회원으로부터 필요한 개인정보를 수집합니다. 

단, 회원의 귀책사유로 인해 노출된 정보에 대해 운영자는 일체의 책임을 지지 않습니다.

운영자는 회원이 미풍양속에 저해되거나 국가안보에 위배되는 게시물 등 위법한 게시물을 등록 · 배포할 경우 관련기관의 요청이 있을시 회원의 자료를 열람 및 해당 자료를 관련기관에 제출할 수 있습니다

　

### 제 6조 회원 탈퇴 및 자격 상실

1. 회원은 회사에 언제든지 자신의 회원 등록 말소(회원 탈퇴)를 요청할 수 있으며 회사는 위 요청을 받은 즉시 해당 회원의 회원 등록 말소를 위한 절차를 밟습니다.
2. 회원 탈퇴가 이루어진 경우 커뮤니티 서비스, 기타 공용 게시판 등에 등록된 회원의 게시물은 일체 삭제됩니다.
3. 회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원의 회원자격을 적절한 방법으로 제한 및 정지, 상실시킬 수 있습니다.
    - 다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는 경우
    - 서비스를 이용하여 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우
    - 해당 회원에 대한 타 회원들의 신고 누적이 일정 횟수 이상 쌓였을 경우
4.  회사가 회원의 회원자격을 상실시키기로 결정한 경우에는 회원등록을 말소한 후 제 7조에서 정한 방법으로 회원에게 통지할 수 있습니다

　

### 제 7조 회원에 대한 통지

회사가 특정 회원에게 서비스에 관한 통지를 하는 경우 회원정보에 등록된 메일주소를 사용할 수 있습니다

　

### 제 8조 회원의 의무

1. 회원은 본 약관에서 규정하는 사항과 운영자가 정한 제반규정, 공지사항 및 운영정책 등 사이트가 공지하는 사항 및 관계법령을 준수하여야 하며, 기타 사이트의 업무에 방해가 되는 행위, 사이트의 명예를 손상시키는 행위를 해서는 안됩니다.
2. 회원은 사이트의 명시적 동의가 없는 한 서비스의 이용권한, 기타 이용계약상 지위를 타인에게 양도, 증여할 수 없으며, 이를 담보로 제공할 수 없습니다.
3. 회원은 아이디 관리에 상당한 주의를 기울여야 하며, 운영자나 사이트의 동의 없이 제3자에게 아이디를 제공하여 이용하게 할 수 없습니다.
4. 회원은 운영자와 사이트 및 제3자의 지적 재산권을 침해해서는 안됩니다.
5. 회원은 스토킹(stalking) 등 다른 회원을 괴롭히는 행위를 해서는 안됩니다.
6. 회원은 불특정 다수의 자를 대상으로 하여 광고 또는 선전을 게시하거나 음란물을 게시하는 행위를 해서는 안됩니다.
7. 회원의 의무를 다하지 못한 회원이 있을 경우 회사는 본 약관 제6조 제 3, 4항에서 정한 바에 따라 회원의 회원자격을 적절한 방법으로 제한 및 정지, 상실시킬 수 있습니다. 또한, 회원은 그 귀책사유로 인하여 회사나 다른 회원이 입은 손해를 배상할 책임이 있습니다.

　

### 제 9조 운영자의 의무

1. 운영자는 이용회원으로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 가급적 빨리 처리하여야 합니다. 다만, 개인적인 사정으로 신속한 처리가 곤란한 경우에는 사후에 공지 또는 이용회원에게 채팅, 이메일 등을 보내는 등 최선을 다합니다.
2. 운영자는 계속적이고 안정적인 사이트 제공을 위하여 설비에 장애가 생기거나 유실된 때에는 이를 지체 없이 수리 또는 복구할 수 있도록 사이트에 요구해야합니다.

　

### 제 10조 공개 게시물의 삭제 또는 이용제한

1. 회원의 공개게시물의 내용이 다음 각 호에 해당하는 경우 회사는 해당 공개게시물에 대한 접근을 임시적으로 차단하는 조치를 취할 수 있고, 타 회원의 신고가 일정 횟수 이상 누적 될 경우 해당 게시물을 삭제 또는 해당 회원의 회원 자격을 제한, 정지 또는 상실시킬 수 있습니다.
    - 불필요하거나 승인되지 않은 광고나 홍보물을 게재하는 경우
    - 음란물, 욕설 등 공서양속에 위반되는 내용의 정보, 문장, 도형 등을 유포하는 내용
    - 다른 회원 또는 제3자를 비방하거나 중상 모략으로 명예를 손상시키는 내용
    - 범죄행위와 관련이 있다고 판단되는 내용
    - 다른 회원 또는 제3자의 저작권 등 기타 권리를 침해하는 내용
    - 종교적, 정치적 분쟁을 야기하는 내용으로서, 이러한 분쟁으로 인하여 회사의 업무가 방해되거나 방해되리라고 판단되는 경우6
    - 타인의 개인정보, 사생활을 침해하거나 명예를 손상시키는 경우
    - 동일한 내용을 중복하여 다수 게시하는 등 게시의 목적에 어긋나는 경우
2. 회원의 공개게시물로 인한 법률상 이익 침해를 근거로, 다른 회원 또는 제3자가 회원 또는 회사를 대상으로 하여 민형사상의 법적 조치(예: 고소, 가처분신청, 손해배상청구소송)를 취하는 동시에 법적 조치와 관련된 게시물의 삭제를 요청해오는 경우, 회사는 동 법적 조치의 결과(예: 검찰의 기소, 법원의 가처분결정, 손해배상판결)가 있을 때까지 관련 게시물에 대한 접근을 잠정적으로 제한할 수 있습니다.

　

### 제 11조 게시물에 대한 저작권

1. 회원이 사이트 내에 게시한 게시물의 저작권은 게시한 회원에게 귀속됩니다. 또한 사이트는 게시자의 동의 없이 게시물을 상업적으로 이용할 수 없습니다. 다만 비영리 목적인 경우는 그러하지 아니하며, 또한 서비스 내의 게재권을 갖습니다.
2. 회원은 서비스를 이용하여 취득한 정보를 임의 가공, 판매하는 행위 등 서비스에 게재된 자료를 상업적으로 사용할 수 없습니다.
3. 운영자는 회원이 게시하거나 등록하는 사이트 내의 내용물, 게시 내용에 대해 제12조 각 호에 해당된다고 판단되는 경우 사전통지 없이 삭제하거나 이동 또는 등록 거부할 수 있습니다.

　

### 부칙

본 약관은 2023년 8월 20일부터 적용됩니다`;

export default CommunityPolicyText;
